import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../Assets/eloria-logo.png';

const Nav = () => {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	return (
		<div className="nav-bg">
			<div className='navbar-main'>
				<div className="container-main">
					<div className="navbar-box">
						<div className="logo-div">
							<img src={logo} className='nav-logo' alt="" />
						</div>
						{/* Desktop Navigation */}
						<div className="nav-items desktop-nav">
							<ul className='mb-0'>
								<li><Link to='/'>Home</Link></li>
								<li><Link to='/about'>About us</Link></li>
								<li><Link to='/acadamics'>Acadamics</Link></li>
								<li><Link to='/admission'>Admission</Link></li>
								<li><Link to='/'>Programmes</Link></li>
								<li><Link to='/contact'>Contact us</Link></li>
							</ul>
						</div>
						{/* Mobile Menu Icon */}
						<button
							className="mobile-menu-btn"
							onClick={toggleSidebar}
							aria-label="Toggle menu"
						>
							<i className="ri-menu-line"></i>
						</button>
						{/* Mobile Sidebar */}
						<div className={`mobile-sidebar ${isSidebarOpen ? 'open' : ''}`}>
							<div className="sidebar-content">
								<button
									className="close-btn"
									onClick={toggleSidebar}
									aria-label="Close menu"
								>
									<i className="ri-close-line"></i>
								</button>
								<ul className='mobile-nav-list'>
									<li><Link className='mobile-nav-items' to='/' onClick={toggleSidebar}>Home</Link></li>
									<li><Link className='mobile-nav-items' to='/about' onClick={toggleSidebar}>About us</Link></li>
									<li><Link className='mobile-nav-items' to='/acadamics' onClick={toggleSidebar}>Acadamics</Link></li>
									<li><Link className='mobile-nav-items' to='admission' onClick={toggleSidebar}>Admission</Link></li>
									<li><Link className='mobile-nav-items' to='/' onClick={toggleSidebar}>Programmes</Link></li>
									<li><Link className='mobile-nav-items' to='/contact' onClick={toggleSidebar}>Contact us</Link></li>
								</ul>
							</div>
						</div>
						{/* Overlay */}
						{isSidebarOpen && (
							<div className="sidebar-overlay" onClick={toggleSidebar}></div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Nav;